<template>
    <div class="row_center_center popup_container" v-if="show">
        <div class="column_center_start QRCode">
            <p>請將QR碼給店員掃描</p>
            <QRCode :value="couponId" :size="250" level="H" />
            <button @click="show = false">返回</button>
        </div>
    </div>
</template>
<script>
import QRCode from "qrcode.vue";
export default {
    components: {
        QRCode,
    },
    data() {
        return {
            show: false
        };
    },
    computed: {
        couponId() {
            const params = this.$route.params;
            return params.id;
        },
    },
}
</script>
<style lang="scss">
.popup_container {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba($color: #000000, $alpha: 0.9);

    .QRCode {
        width: 84vw;
        padding: 20px 10px;
        background-color: #fff;
        border-radius: 6px;
    }

    p {
        text-align: center;
        margin-bottom: 20px;
        font-family: PingFang SC;
        font-weight: 700;
        font-size: 22px;
        color: #FD5001;
    }

    button {
        width: 84%;
        height: 50px;
        border: none;
        font-size: 20px;
        font-weight: 500;
        font-family: PingFang SC;
        color: #000;
        border-radius: 8px;
        background-color: #EEEEEE;
        margin-top: 20px;
    }
}
</style>